import React from "react";
import userFloat from "../../assets/images/Tec1.png";

const FloatingUserButton: React.FC = () => (
  <a
    href="/contacto"
    className="floating-user-button"
    style={{
      position: "fixed",
      bottom: "80px",
      right: "16px",
      zIndex: 9999,
      width: "135px",
      height: "135px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      background: "none",
      borderRadius: 0,
      boxShadow: "none",
      padding: 0,
    }}
    aria-label="Contacto Humano"
  >
    <style>
      {`
        @media (max-height: 675px) {
          .floating-user-button {
            width: 100px !important;
            height: 100px !important;
          }
        }
      `}
    </style>
    <img
      src={userFloat}
      alt="Contacto Humano"
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
    />
  </a>
);

export default FloatingUserButton; 